import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  vertical-align: middle;\n  ", "\n  border-radius: 0.25rem;\n  cursor: ", ";\n  user-select: none;\n  font-family: 'Raleway', serif;\n  line-height: 1.5;\n  font-weight: 600;\n  text-align: center;\n  white-space: nowrap;\n  ", "\n  transition: color 0.15 ease-in-out, background-color 0.15s ease-in-out,\n    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  &,\n  &:hover,\n  &:focus,\n  &:active,\n  &:visited {\n    text-decoration: none;\n  }\n  &:hover {\n  }\n  &:focus {\n    outline: 0;\n    box-shadow: 0 0 0 0.1875rem rgba(242, 240, 236, 0.35);\n  }\n  &:disabled {\n    opacity: 0.6;\n  }\n  &:not(:disabled):active {\n    &:focus {\n      box-shadow: 0 0 0 0.1875rem rgba(242, 240, 236, 0.35);\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from 'styled-components';
import { upperFirst } from 'lodash';

var colorCssTemplate = function colorCssTemplate(args, t, brand) {
  var _args$map = args.map(function (arg) {
    return t["".concat(brand).concat(upperFirst(arg))] || arg;
  }),
      _args$map2 = _slicedToArray(_args$map, 4),
      bg = _args$map2[0],
      hover = _args$map2[1],
      border = _args$map2[2],
      text = _args$map2[3];

  console.log({
    bg: bg,
    hover: hover,
    border: border,
    text: text
  }, args, brand, t);
  return "\n    background-color: ".concat(bg, ";\n    border: 1px solid ").concat(border, ";\n    color: ").concat(text, ";\n\n    &:hover {\n      background-color: ").concat(hover, ";\n      ").concat(bg === border && "border-color: ".concat(hover, ";"), "\n    }\n\n    &:not(:disabled):active {\n      background-color: ").concat(hover, ";\n      ").concat(bg === border && "border-color: ".concat(hover, ";"), "\n    }\n  ");
};

var colorsCss = function colorsCss(_ref) {
  var t = _ref.theme,
      brand = _ref.brand,
      outline = _ref.outline,
      reverse = _ref.reverse;

  var mod = function () {
    if (outline) return 'outline';
    if (reverse) return 'reverse';
    return 'normal';
  }();

  return colorCssTemplate({
    // bg, hover, border, text
    normal: ['', 'hover', '', 'reverse'],
    outline: ['transparent', 'reverseHover', '', ''],
    reverse: ['reverse', 'reverseHover', 'reverse', '']
  }[mod], t, brand);
};

var StyledButton = styled.button(_templateObject(), function (p) {
  return {
    medium: "\n        font-size: 1rem;\n        padding: 0.75rem 1rem;\n      ",
    small: "\n        font-size: .75rem;\n        padding: 0.375rem .5rem;\n      "
  }[p.size || 'medium'];
}, function (p) {
  return p.disabled ? 'not-allowed' : 'pointer';
}, colorsCss);

var Button = function Button(_ref2) {
  var _ref2$brand = _ref2.brand,
      brand = _ref2$brand === void 0 ? 'primary' : _ref2$brand,
      buttonRef = _ref2.buttonRef,
      children = _ref2.children,
      _ref2$circle = _ref2.circle,
      circle = _ref2$circle === void 0 ? false : _ref2$circle,
      _ref2$disabled = _ref2.disabled,
      disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
      _ref2$outline = _ref2.outline,
      outline = _ref2$outline === void 0 ? false : _ref2$outline,
      onClick = _ref2.onClick,
      _ref2$size = _ref2.size,
      size = _ref2$size === void 0 ? 'medium' : _ref2$size,
      props = _objectWithoutProperties(_ref2, ["brand", "buttonRef", "children", "circle", "disabled", "outline", "onClick", "size"]);

  return /*#__PURE__*/React.createElement(StyledButton, _extends({
    brand: brand,
    circle: circle,
    disabled: disabled,
    outline: outline,
    onClick: onClick,
    ref: buttonRef,
    size: size
  }, props), children);
};

export default Button;